import React from 'react'
import './Secrowbox.css'

const Secrowbox = (props) => {
    return (

        <div className="secrowbox">
            <span className='heading'>{props.title}</span>
            <div
            style={{
                background: props.background
            }}
            className="practice">
                {props.img}
                <div className="matter">
                    <span className='one'>{props.one}</span>
                    <span className='two'>{props.two} </span>
                    <span className='two'>{props.three}</span>
                    <div className="startbutton">
                        <button>{props.bname}</button>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Secrowbox
